<template>
  <span class="product-type">
    <template v-if="bundle">{{$t('types.bundle')}}</template>
    <template v-else>{{$t('types.standard')}}</template>
  </span>
</template>

<script>
export default {
  name: 'product-type',
  props: {
    bundle: {
      type: Boolean,
      required: true,
    },
  },
  i18n: {
    messages: {
      de: {
        types: {
          standard: 'Standard',
          bundle: 'Bundle',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductType.vue?fcfa8cd2